export default "__VITE_ASSET__b8PHtEeD__"